// extracted by mini-css-extract-plugin
export default {"background":"DashboardLogin_background__oLB5H","loginContainer":"DashboardLogin_loginContainer__1MGmb","forgotPassword":"DashboardLogin_forgotPassword__Tm+VX"};